import { atom } from 'recoil';
import { SponsorMode } from '../../apiParticulierService';

export const sponsorState = atom<SponsorMode | undefined>({
    key: 'sponsor',
    default: undefined,
});
